<div class="dashboard-container">

  <app-labdashboard-header (logout)="logout()">
  </app-labdashboard-header>

  <!-- STATS -->

  <app-dashboard-stats [stats]="stats()">
  </app-dashboard-stats>

  <!-- FILTER -->

  <app-requisition-filter (filterChange)="onFilterChange($event)" (createRequisition)="openCreateRequisition()"
    (patientOnboarded)="onPatientOnboarded($event)">
  </app-requisition-filter>


  <!-- TABLE -->
  <app-requisition-table [requisitions]="requisitions()" [loading]="loading()" (uploadReport)="onUploadReport($event)"
    (createRequisition)="onCreateRequisition($event)" (statusUpdate)="onStatusUpdate($event)">

  </app-requisition-table>

</div>